module.exports = __webpack_public_path__ + "assets/img/12.e872c2bd.png";